<template>
  <div class="page-wrapper">
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
    <!-- Consent banner is needed only for Google flows; for default affiliate pages we disable it. -->
    <CookieConsent v-if="shouldShowConsent" />
  </div>
</template>


<script>
import CookieConsent from '@/components/CookieConsent.vue';
import { helpers } from '@/helper/portal_config';

export default {
  name: 'App',
  components: { CookieConsent },
  computed: {
    shouldShowConsent() {
      // When the default affiliate tracking is used, we do not show the consent popup.
      return helpers.tracking_aff !== 'AFFd3fAu1t0';
    },
  },
};
</script>

<style scoped>
.fade-enter,
.fade-leave-to,
.fade-leave-active {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
    
</style>

